<script>
	import { push } from 'svelte-spa-router';
    export let title='';
    export let desc='';
    export let icon='';
    export let link='';

    let hover=false;
    
</script>

<div class="pointer align-self-stretch mb-4 p-3 border-start border-3"
    on:click={()=>push('/'+link)}
    on:mouseenter={()=>hover=true}
    on:mouseleave={()=>hover=false}
    class:bg-light={hover===true}
>
    <h1 class='float-start me-2 mb-5'><i class="bi {icon}"></i></h1>
    <h5 class='fw-bold text-warning mt-2 mb-0 lh-1'>{title}</h5>
    <small class='d-block mt-1 lh-1 text-secondary'>{desc}</small>
</div>

<style>
    .pointer {
        cursor: pointer;
    }
</style>